import type {TuiCountryIsoCode, TuiLanguage, TuiLanguageCommerce, TuiLanguageCore, TuiLanguageEditor, TuiLanguageKit, TuiLanguageLayout, TuiLanguageTable} from '@taiga-ui/i18n/types';

export const TUI_FILIPINO_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: ['Numero', 'Numero ng card'],
    cardExpiry: ['Pag-expire', 'Petsa ng pag-expire'],
};

export const TUI_FILIPINO_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Sikat',
        history: 'Kamakailan',
        placeholder: 'Maghanap',
        hotkey: 'para sa paghahanap',
        all: 'Lahat',
        empty: 'Walang resulta',
    },
};

export const TUI_FILIPINO_LANGUAGE_KIT: TuiLanguageKit = {
    cancel: 'Kanselahin',
    done: 'Tapos na',
    more: 'Higit pa',
    otherDate: 'Ibang petsa...',
    showAll: 'Ipakita lahat',
    hide: 'Itago',
    mobileCalendarTexts: [
        'Pumili ng araw',
        'Pumili ng panahon',
        'Pumili ng mga araw',
    ],
    range: ['Mula', 'Hanggang'],
    countTexts: ['Higit pa', 'Mas kaunti'],
    time: {
        'HH:MM': 'HH:MM',
        'HH:MM AA': 'HH:MM AA',
        'HH:MM:SS': 'HH:MM:SS',
        'HH:MM:SS AA': 'HH:MM:SS AA',
        'HH:MM:SS.MSS': 'HH:MM:SS.MSS',
        'HH:MM:SS.MSS AA': 'HH:MM:SS.MSS AA',
    },
    dateTexts: {
        DMY: 'araw.buwan.taon',
        MDY: 'buwan.araw.taon',
        YMD: 'taon.buwan.araw',
    },
    digitalInformationUnits: ['Byte', 'Kilobyte', 'Megabyte'],
    passwordTexts: ['Ipakita ang password', 'Itago ang password'],
    copyTexts: ['Kopyahin', 'Nakopya'],
    shortCalendarMonths: [
        'Ene',
        'Peb',
        'Mar',
        'Abr',
        'May',
        'Hun',
        'Hul',
        'Ago',
        'Set',
        'Okt',
        'Nob',
        'Dis',
    ],
    pagination: ['Nakaraang pahina', 'Susunod na pahina'],
    fileTexts: {
        loadingError: 'Error sa pag-load',
        preview: 'Preview',
        remove: 'Alisin',
    },
    inputFileTexts: {
        defaultLabelSingle: 'o i-drag dito',
        defaultLabelMultiple: 'o i-drag dito',
        defaultLinkSingle: 'Pumili ng file',
        defaultLinkMultiple: 'Pumili ng mga file',
        maxSizeRejectionReason: 'Masyadong malaki ang file',
        formatRejectionReason: 'Hindi wastong format ng file',
        drop: 'I-drop ang file dito',
        dropMultiple: 'I-drop ang mga file dito',
    },
    multiSelectTexts: {
        all: 'Piliin lahat',
        none: 'Huwag pumili ng anuman',
    },
    confirm: {
        yes: 'Oo',
        no: 'Hindi',
    },
    previewTexts: {
        rotate: 'I-rotate',
    },
    zoomTexts: {
        zoomOut: 'Mag-zoom out',
        zoomIn: 'Mag-zoom in',
        reset: 'I-reset',
    },
    phoneSearch: 'Maghanap ng bansa o code',
};

export const TUI_FILIPINO_LANGUAGE_ADDON_EDITOR: TuiLanguageEditor = {
    colorSelectorModeNames: ['Solidong kulay', 'Kulay gradient'],
    toolbarTools: {
        undo: 'I-undo',
        redo: 'I-redo',
        font: 'Font',
        fontStyle: 'Estilo ng font',
        fontSize: 'Laki ng font',
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        strikeThrough: 'Strikethrough',
        justify: 'I-justify',
        justifyLeft: 'I-justify left',
        justifyCenter: 'I-justify center',
        justifyRight: 'I-justify right',
        justifyFull: 'I-justify full',
        list: 'List',
        indent: 'Palakihin ang indent',
        outdent: 'Paliitin ang indent',
        unorderedList: 'Unordered list',
        orderedList: 'Ordered list',
        quote: 'Quote',
        foreColor: 'Kulay ng text',
        backColor: 'Kulay ng background',
        hiliteColor: 'Kulay ng highlight',
        clear: 'I-clear',
        link: 'Link',
        attach: 'I-attach ang file',
        tex: 'I-insert ang TeX',
        code: 'Code',
        image: 'I-insert ang image',
        insertHorizontalRule: 'I-insert ang horizontal rule',
        superscript: 'Superscript',
        subscript: 'Subscript',
        insertTable: 'I-insert ang table',
        insertGroup: 'I-insert ang group',
        hiliteGroup: 'I-highlight ang group',
        removeGroup: 'I-remove ang group',
        insertAnchor: 'I-insert ang anchor',
        mergeCells: 'I-merge ang cells',
        splitCells: 'I-split ang cells',
        rowsColumnsManaging: 'Pamahalaan ang rows at columns',
        cellColor: 'Kulay ng cell',
        setDetails: 'I-set ang details',
        removeDetails: "I-remove ang details",
    },
    editorEditLink: {
        urlExample: 'halimbawa.com',
        anchorExample: 'anchor',
    },
    editorTableCommands: [
        ['I-insert ang column bago', 'I-insert ang column pagkatapos'],
        ['I-insert ang row bago', 'I-insert ang row pagkatapos'],
        ['I-remove ang column', 'I-remove ang row'],
    ],
    editorCodeOptions: ['Code sa text', 'Code block'],
    editorFontOptions: {
        small: 'Maliit',
        large: 'Malaki',
        normal: 'Normal',
        title: 'Title',
        subtitle: 'Subtitle',
    },
};

export const TUI_FILIPINO_LANGUAGE_ADDON_TABLE: TuiLanguageTable = {
    showHideText: 'Ipakita/Itago',
    paginationTexts: {
        pages: 'Mga pahina',
        linesPerPage: 'Mga linya bawat pahina',
        of: 'ng',
    },
};

export const TUI_FILIPINO_LANGUAGE_CORE: TuiLanguageCore = {
    months: [
        'Enero',
        'Pebrero',
        'Marso',
        'Abril',
        'Mayo',
        'Hunyo',
        'Hulyo',
        'Agosto',
        'Setyembre',
        'Oktubre',
        'Nobyembre',
        'Disyembre',
    ],
    close: 'Isara',
    clear: 'I-clear',
    nothingFoundMessage: 'Walang resulta',
    defaultErrorMessage: 'Hindi wastong halaga',
    spinTexts: ['Nakaraan', 'Susunod'],
    shortWeekDays: ['Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab', 'Lin'],
    countries: {} as Record<TuiCountryIsoCode, string>,
};

export const TUI_FILIPINO_LANGUAGE: TuiLanguage = {
    name: 'filipino',
    ...TUI_FILIPINO_LANGUAGE_CORE,
    ...TUI_FILIPINO_LANGUAGE_KIT,
    ...TUI_FILIPINO_LANGUAGE_ADDON_TABLE,
    ...TUI_FILIPINO_LANGUAGE_ADDON_COMMERCE,
    ...TUI_FILIPINO_LANGUAGE_ADDON_EDITOR,
    ...TUI_FILIPINO_LANGUAGE_LAYOUT,
};